import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { BrandsApi } from "./API/BrandsApi";
import { LabelsApi } from "./API/LabelsApi";
import { RecipeApi } from "./API/RecipesApi";
import { menuCategoriesApi } from "./API/MenuCategoriesApi";
import { menuItemsApi } from "./API/MenuItems";

export const store = configureStore({
  reducer: {
    [BrandsApi.reducerPath]: BrandsApi.reducer,
    [LabelsApi.reducerPath]: LabelsApi.reducer,
    [RecipeApi.reducerPath]: RecipeApi.reducer,
    [menuCategoriesApi.reducerPath]: menuCategoriesApi.reducer,
    [menuItemsApi.reducerPath]: menuItemsApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(BrandsApi.middleware)
      .concat(LabelsApi.middleware)
      .concat(RecipeApi.middleware)
      .concat(menuCategoriesApi.middleware)
      .concat(menuItemsApi.middleware),
});

setupListeners(store.dispatch);
